export default __webpack_public_path__ + "static/media/Logo.c293ce7c.svg";